import { useConfiguratorStore } from "@/configurator/data/store/store";
import type { ConfiguratorStatePort } from "@/configurator/domain/ports/configuratorState";

/**
 * The zustand store behind the domain's state port. Commands read the action
 * off the current state on every call, so the adapter never holds a stale one.
 */
export const configuratorStateAdapter: ConfiguratorStatePort = {
  useSelect: useConfiguratorStore,
  commands: {
    setQuantity: (quantity) =>
      useConfiguratorStore.getState().setQuantity(quantity),
    setActiveModel: (modelId) =>
      useConfiguratorStore.getState().setActiveModel(modelId),
    setOption: (payload) => useConfiguratorStore.getState().setOption(payload),
    toggleOption: (payload) =>
      useConfiguratorStore.getState().toggleOption(payload),
    setConfig: (config) => useConfiguratorStore.getState().setConfig(config),
    applySharedSelection: (selection) =>
      useConfiguratorStore.getState().applySharedSelection(selection),
    downloadActiveModel: () =>
      useConfiguratorStore.getState().downloadActiveModel(),
  },
};
